import { GetterTree } from "vuex";
import { TrialPeriodState } from "@/types/store/clientzone/trial_period";
import { RootState } from "@/types/store/clientzone";
import { TrialPeriodData } from "@/types";

export const getters: GetterTree<TrialPeriodState, RootState> = {
  GET_TRIAL_PERIOD: (state): Array<TrialPeriodData> => state.trialPeriod
}
